// Types
import { GetStream_stream } from 'api/streams/types/GetStream';
import { HighlightClip } from '../StreamHighlights/types';
// Ui
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
import VideoPlayer from 'ui/VideoPlayer/VideoPlayer';
import SocialShareQRButton from 'ui3/SocialShareQRButton/SocialShareQRButton';
// Components
import VideoHeader from 'components/common3/VideoHeader/VideoHeader';
// Styles
import styles from './StreamClipHero.module.scss';

type StreamClipHeroProps = {
  clip: HighlightClip;
  store: GetStream_stream['store'];
  shareUrlPath: string;
  onClose: () => void;
};

const StreamClipHero = ({
  clip,
  store,
  shareUrlPath,
  onClose,
}: StreamClipHeroProps): JSX.Element => (
  <section className={styles.root} aria-label="Clip player">
    <div className={styles.videoRegion}>
      <div className={styles.videoFrame}>
        <VideoPlayer
          key={clip.id}
          wrapperClassName={styles.player}
          videoClassName={styles.video}
          src={clip.clipUrl}
          autoPlay
          volumeControl="speaker"
          videoPoster={clip.thumbnailUrl || undefined}
        />
      </div>

      <button
        type="button"
        className={styles.close}
        aria-label="Close clip"
        onClick={onClose}
      >
        <MillionsIcon name="close" size={24} />
      </button>
    </div>

    <div className={styles.header}>
      <VideoHeader
        title={clip.title}
        store={store}
        actionButtons={
          <SocialShareQRButton
            modalTitle="Share Clip"
            modalText="Share this clip with your friends"
            path={shareUrlPath}
            twitterText={clip.title}
            icon
            size="medium"
          />
        }
      />
    </div>
  </section>
);

export default StreamClipHero;
